// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as UseIsPLP$Showside from "../hook/UseIsPLP.bs.js";
import * as BasicTypes$Showside from "../types/BasicTypes.bs.js";
import * as LocalStorage$Showside from "../utils/LocalStorage.bs.js";
import * as ViewportContext$Showside from "./ViewportContext.bs.js";
import * as CustomerBombayShirts$Showside from "../customers/CustomerBombayShirts.bs.js";
import * as ConfigurationProvider$Showside from "./ConfigurationProvider.bs.js";
var initialValue_options = [];
function initialValue_onChangeGridDensity(prim) {}
var initialValue = {
  gridColumns: /* FourColumnGrid */3,
  isZoomEnabled: false,
  isSmallestPossibleGrid: false,
  options: initialValue_options,
  onChangeGridDensity: initialValue_onChangeGridDensity
};
var context = React.createContext(initialValue);
var provider = context.Provider;
function GridDensityZoomProvider(Props) {
  var children = Props.children;
  var isBombayshirts = CustomerBombayShirts$Showside.useIsBombay(undefined);
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var match$1 = ViewportContext$Showside.use(undefined);
  var isMobile = match$1.isMobile;
  var isPLP = UseIsPLP$Showside.useIsPLP(undefined);
  var isZoomEnabled = match.settings.gridDensityZoomEnabled && isPLP;
  var options = isBombayshirts && isMobile ? [/* OneColumnGrid */0, /* TwoColumnGrid */1] : isBombayshirts ? [/* TwoColumnGrid */1, /* ThreeColumnGrid */2] : isMobile ? [/* OneColumnGrid */0, /* TwoColumnGrid */1, /* FourColumnGrid */3] : [/* TwoColumnGrid */1, /* ThreeColumnGrid */2, /* FourColumnGrid */3, /* TwelveColumnGrid */8];
  var defaultGridColumns = isBombayshirts && isMobile ? /* TwoColumnGrid */1 : isBombayshirts ? /* ThreeColumnGrid */2 : isMobile ? /* TwoColumnGrid */1 : /* FourColumnGrid */3;
  var match$2 = React.useState(function () {
    return Belt_Option.mapWithDefault(LocalStorage$Showside.get(undefined, "gridColumns"), defaultGridColumns, BasicTypes$Showside.GridColumns.fromString);
  });
  var setCustomGridColumns = match$2[1];
  var gridColumns = isZoomEnabled ? match$2[0] : defaultGridColumns;
  var gridColumns$1 = isMobile ? gridColumns > /* FourColumnGrid */3 ? /* FourColumnGrid */3 : gridColumns : gridColumns < /* TwoColumnGrid */1 ? /* TwoColumnGrid */1 : gridColumns;
  var isSmallestPossibleGrid = isZoomEnabled ? isMobile ? gridColumns$1 === /* FourColumnGrid */3 : gridColumns$1 >= /* TwelveColumnGrid */8 : false;
  var handleChangeGridColumns = React.useCallback(function (gridColumns) {
    if (isZoomEnabled) {
      Curry._1(setCustomGridColumns, function (param) {
        return gridColumns;
      });
      return LocalStorage$Showside.set(undefined, "gridColumns", BasicTypes$Showside.GridColumns.toString(gridColumns));
    }
  }, [isZoomEnabled]);
  var ctxValue = React.useMemo(function () {
    return {
      gridColumns: gridColumns$1,
      isZoomEnabled: isZoomEnabled,
      isSmallestPossibleGrid: isSmallestPossibleGrid,
      options: options,
      onChangeGridDensity: handleChangeGridColumns
    };
  }, [gridColumns$1, isZoomEnabled, isSmallestPossibleGrid, handleChangeGridColumns]);
  return React.createElement(provider, {
    value: ctxValue,
    children: children
  });
}
GridDensityZoomProvider.displayName = "GridDensityZoomProvider";
function use(param) {
  return React.useContext(context);
}
var mobileMax = /* FourColumnGrid */3;
var desktopMin = /* TwoColumnGrid */1;
var make = GridDensityZoomProvider;
export { initialValue, context, provider, mobileMax, desktopMin, make, use };
/* context Not a pure module */